'use client';

import { Box } from '@terra/ui-styled-system';
import { ArrowDown02Icon, ArrowUp02Icon } from '@terra/ui-icons';
import type { StreamingMessageDirection } from './streaming-messages.types';

export function StreamingMessageDirectionIcon({
  direction,
}: {
  direction: StreamingMessageDirection;
}) {
  if (direction === 'sent') {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100%"
        color="blue.11"
      >
        <ArrowUp02Icon size={12} />
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100%"
      color="green.11"
    >
      <ArrowDown02Icon size={12} />
    </Box>
  );
}
